import React from 'react'
import styles from './index.module.scss'
import TrialHeaderPc from '../../public/trial_header_for_pc.png'
import TrialHeaderSp from '../../public/trial_header_for_sp.png'
import ReservationMoveButton from '../../components/ReservationMoveButton'
import { THRESHOLD_SP_WIDTH } from '../../utils/constants'

const TrialHeaderForAB = ({
  isCountdownActive,
}: {
  isCountdownActive?: boolean
}) => {
  return (
    <>
      <section
        className={styles.headerContainer}
        style={{
          backgroundColor: '#fff4f0',
          marginTop: isCountdownActive ? 44 : 0,
        }}
      >
        <div className={styles.heroWrapper}>
          <div className={styles.heroImageContainer}>
            <picture className={styles.mainImage}>
              <source
                media={`(max-width: ${THRESHOLD_SP_WIDTH}px)`}
                srcSet={TrialHeaderSp.src}
              />
              <img src={TrialHeaderPc.src} alt="" />
            </picture>
          </div>
        </div>

        <ReservationMoveButton
          moveToId="reservation-step-summary"
          isAB={true}
        />
      </section>
    </>
  )
}

export default TrialHeaderForAB
